





































































































































import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";
import ImageSize from "@/components/ImageSize.vue";
extend("required", {
  ...required,
  message: "Vui lòng điền đầy đủ thông tin!"
});
extend("numeric", {
  ...numeric,
  message: "Vui lòng chỉ nhập số!"
});

export default Vue.extend({
  name: "ProductsForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    ImageSize
  },
  data() {
    return {
      id: null,
      file: null,
      name: null,
      code: null,
      category: null,
      description: null,
      image: null,
      price: null,
      point: null,
      upLoading: false,
      requireQR: null,
      exchangePoint: null,
      bonusPoint: null
    };
  },
  methods: {
    prompt() {
      this.$buefy.dialog.prompt({
        message: `Tên danh mục?`,
        confirmText: "Lưu",
        cancelText: "Hủy",
        inputAttrs: {
          placeholder: "vd: Thuốc bảo vệ thực vật"
        },
        trapFocus: true,
        onConfirm: value => this.createCategory(value)
      });
    },
    removeImg(e) {
      e.stopPropagation();
      this.image = null;
    },
    ...mapActions({
      uploadImg: "product/uploadImg",
      createNewProduct: "product/createNewProduct",
      fechListProduct: "product/fechListProduct",
      updateProduct: "product/updateProduct",
      createCategory: "productCategory/createCategory"
    }),
    ...mapMutations({
      closeModal: "product/closeModal"
    }),

    async uploadImage() {
      this.upLoading = true;
      try {
        const imageLink = await this.uploadImg(this.file);
        this.upLoading = false;
        this.image = imageLink;
      } catch (err) {
        this.upLoading = false;
        this.$buefy.toast.open({
          message: "Tải hình ảnh thất bại!",
          type: "is-danger",
          position: "is-top-right"
        });
      }
    },
    addNewProduct() {
      const newProduct = {
        name: this.name,
        code: this.code,
        category: this.category,
        description: this.description,
        image: this.image,
        price: this.price,
        point: this.point,
        exchangePoint: this.exchangePoint,
        requireQR: this.requireQR,
        bonusPoint: +this.bonusPoint
      };
      this.createNewProduct(newProduct);
    },
    editProduct() {
      const newProduct = {
        name: this.name,
        code: this.code,
        category: this.category,
        description: this.description,
        image: this.image,
        price: this.price,
        point: this.point,
        exchangePoint: this.exchangePoint,
        requireQR: this.requireQR,
        bonusPoint: +this.bonusPoint
      };
      this.updateProduct({ id: this.id, product: newProduct });
    }
  },
  updated() {
    this.id = this.productModal._id;
    this.name = this.productModal.name;
    this.code = this.productModal.code;
    this.category = this.productModal.category
      ? this.productModal.category._id
      : null;
    this.description = this.productModal.description;
    this.image = this.productModal.image;
    this.price = this.productModal.price;
    this.point = this.productModal.point;
    this.requireQR = this.productModal.requireQR;
    this.exchangePoint = this.productModal.exchangePoint;
    this.bonusPoint = this.productModal.bonusPoint;
  },
  computed: {
    ...mapGetters({
      productModal: "product/productModal",
      categorys: "productCategory/categorys"
    })
  }
});
